<template>
  <div class="chat">
    <!-- <pre>{{formParamSRSt}}</pre> -->
    <!-- {{formParamSRSt.interactive_message_type}} -->
    <!-- {{linkRows}} -->
    <div class="chat-box">
      <div class="chats">
        <div class="chat chat-right">
          <div class="chat-body">
            <div class="chat-bubble">
              <div class="chat-content">
                <div class="chat-img-group clearfix"
                  v-if="formParamSRSt.message.message_type == 'image' && formParamSRSt.interactive_message_type != 'list_text'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px" alt :src="formParamSRSt.message.file_url" />
                  </a>
                </div>
                <ul class="attach-list"
                  v-if="formParamSRSt.message.message_type == 'document' && formParamSRSt.interactive_message_type != 'list_text'">
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamSRSt.message.file_url" target="_blank">File</a>
                  </li>
                </ul>
                <ul class="attach-list"
                  v-if="formParamSRSt.message.message_type == 'video' && formParamSRSt.interactive_message_type != 'list_text'">
                  <li v-if="formParamSRSt.message.file_url">
                    <div class="video-preview-wrapper mb-2">
                      <video controls width="100%" max-width="400"
                        style="border-radius: 8px; max-height: 250px; background-color: #000;">
                        <source :src="formParamSRSt.message.file_url" type="video/mp4" />
                        Browser Anda tidak mendukung tag video HTML5.
                      </video>
                    </div>
                    <!-- <div>
                      <i class="fa fa-file"></i>
                      <a :href="formParamSRSt.message.file_url" target="_blank">
                        Buka Video di Tab Baru
                      </a>
                    </div> -->
                  </li>
                </ul>
                <p v-html="$util.formatMessage(formParamSRSt.message.text)" v-if="formParamSRSt.message.text != ''"
                  v-linkified></p>
                <span v-html="formParamSRSt.footer_message" class="text-muted" style="font-size:10px;" v-linkified
                  v-if="formParamSRSt.footer_message_status == true && formParamSRSt.interactive_message_status == true"></span>

                <template v-if="formParamSRSt.buttons && formParamSRSt.buttons.length && formParamSRSt.interactive_message_status == true">
                  <div v-if="formParamSRSt.interactive_message_type == 'text_reply'">
                    <!-- {{ formParamSRSt.buttons }} -->
                    <!-- <div class="text-left" v-for="(auto_reply_button_id, idx) in formParamSRSt.buttons" :key="idx" v-if="auto_reply_button_id!=''">
                    <span v-html="getTextReplyLabelById(auto_reply_button_id, idx)"></span>
                  </div> -->
                    <div class="text-left">

                      <div v-html="getTextReplyLabelByIdV2()"></div>
                    </div>
                  </div>

                </template>
              </div>

              <div class="chat-content"
                v-if="(formParamSRSt.message.message_type == 'image' || formParamSRSt.message.message_type == 'video' || formParamSRSt.message.message_type == 'document') && formParamSRSt.interactive_message_type == 'list_text'">
                <div class="chat-img-group clearfix" v-if="formParamSRSt.message.message_type == 'image'">
                  <a class="chat-img-attach" href="javascript:void(0)">
                    <img style="max-height:200px" alt :src="formParamSRSt.message.file_url" />
                  </a>
                </div>
                <ul class="attach-list" v-if="formParamSRSt.message.message_type == 'document'">
                  <li>
                    <i class="fa fa-file"></i>
                    <a :href="formParamSRSt.message.file_url" target="_blank">File</a>
                  </li>
                </ul>
                <ul class="attach-list" v-if="formParamSRSt.message.message_type == 'video'">
                  <li v-if="formParamSRSt.message.file_url">
                    <div class="video-preview-wrapper mb-2">
                      <video controls width="100%" max-width="400"
                        style="border-radius: 8px; max-height: 250px; background-color: #000;">
                        <source :src="formParamSRSt.message.file_url" type="video/mp4" />
                        Browser Anda tidak mendukung tag video HTML5.
                      </video>
                    </div>
                    <!-- <div>
                      <i class="fa fa-file"></i>
                      <a :href="formParamSRSt.message.file_url" target="_blank">
                        Buka Video di Tab Baru
                      </a>
                    </div> -->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    formParam: {
      type: Object,
      default: null
    },
    buttonsRows: {
      type: Array,
      default: () => [{ button_text: "" }]
    },
    linkRows: {
      type: Array
    },
    textReplyRows: {
      type: Array
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  watch: {},
  computed: {
    formParamSRSt() {
      if (this.formParam && this.formParam.message) {
        return this.formParam;
      }
      return this.$store.state.omniwa.broadcastParamSt;
    }
  },
  methods: {
    getTextReplyLabelByIdV2() {
      var number = 1;
      let htmlData = "";
      const buttons = Array.isArray(this.formParamSRSt.buttons)
        ? this.formParamSRSt.buttons
        : [];
      buttons.forEach(id => {
        if (id != "") {
          const buttonId = id && typeof id === "object" ? id.id : id;
          let arr = (this.textReplyRows || []).find(msgs => msgs.id === buttonId);
          if (arr != null && typeof arr.title != "undefined") {
            htmlData += "<br />" + number + ". " + arr.title + "";
            number++;
          }
        }
      });
      return htmlData;
    },
    getTextReplyLabelById(id, idx) {
      let arr = (this.textReplyRows || []).find(msgs => msgs.id === id);
      if (arr != null && typeof arr.title != "undefined" && typeof (arr) != 'undefined') {
        return (idx + 1) + '. ' + arr.title;
      } else {
        return "";
      }
    },
    getButtonLabelById(id) {
      let arr = (this.buttonsRows || []).find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        return arr.button_text;
      } else {
        return "";
      }
    },
    getLinkLabelById(id) {
      let arr = (this.linkRows || []).find(msgs => msgs.id === id);
      if (arr != null && typeof arr.button_text != "undefined") {
        if (arr.button_type == "call") {
          return '<i class="fa fa-phone"></i> ' + arr.button_text;
        } else {
          return '<i class="fa fa-external-link"></i> ' + arr.button_text;
        }
      } else {
        return "";
      }
    },
    messageFilter(message) {
      return message.replace(/\r?\n/g, "<br />");
    }
  },
  async created() { },
  beforeDestroy() { },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "buttons-add"
};
</script>


// WEBPACK FOOTER //
// src/views/broadcast/components/preview.vue